import { getsitesettings } from '@vue/services/api/cart.api'
import { SITE_ID } from '@vue/common/constants/config'
import { ProductTypes } from '@vue/common/constants/productTypes'

export const startKlaviyoCheckout = async (orderInfo, emailAddress, orderStatus) => {
    const siteInfoResponse = await getsitesettings(SITE_ID);
    const siteInfo = siteInfoResponse?.data;

    if(!window.klaviyo) return false;

    if (!siteInfo)
        return;

    if (orderInfo && orderInfo.lines && siteInfo && siteInfo.isSiteAllowed) {
        window.klaviyo.identify({
            'email': emailAddress
        });
        
        const affiliateCode = sessionStorage.getItem('affiliateCode') || null;
        let cartId = "";
        let orderTypeUrl = "";
        let guarantee = "";
        let category = "";
        let metric = "Started Checkout";

        if (orderInfo.product.id === ProductTypes.SELL_BACK) {
            metric = "Started Checkout Sell";
            category = "Sell";
            cartId = `${siteInfo.buyCartId}${orderInfo.id}`;
            orderTypeUrl = "/selling/view-cart";
        } else {
            metric = "Started Checkout Buy";
            category = "Buy";
            cartId = `${siteInfo.sellCartId}${orderInfo.id}`;
            orderTypeUrl = "/checkout/view-cart";
        }

        if (orderInfo && orderInfo.buyBackGuarantee === true) {
            guarantee = `${orderInfo.product.name}:${(orderInfo.deliverySlot.price !== 0 ? (orderInfo.currency.symbol + orderInfo.deliverySlot.price) : "Free")} 
            , Buyback Guarantee: ${orderInfo.currency.symbol}4`;
        } else {
            guarantee = `${orderInfo.product.name}:${(orderInfo.deliverySlot.price !== 0 ? (orderInfo.currency.symbol + orderInfo.deliverySlot.price) : "Free")}`;
        }
        if (orderInfo && orderInfo.refundGuarantee === true) {
            guarantee = `${orderInfo.product.name}:${(orderInfo.deliverySlot.price !== 0 ? (orderInfo.currency.symbol + orderInfo.deliverySlot.price) : "Free")} 
            ,Refund Guarantee:{orderInfo.currency.symbol}3`;
        }

        let cartItems = [];
        let total = 0;

        cartItems = orderInfo.lines.map(function (line) {
            return {
                sku: line.currency.code,
                name: line.currency.name,
                description: line.currency.name,
                category: category,
                "other": guarantee,
                "unitPrice": line.price,
                "salePrice": line.rate.toString().slice(0, (line.rate.toString().indexOf(".")) + 5),
                "quantity": line.qty,
                "totalPrice": line.total.toFixed(2),
                "imageUrl": window.location.origin + "/assets/img/icons/flags/" + line.currency.code.toLowerCase() + ".svg",
                "productUrl": ""
            }
        });
        const itemNames = cartItems.map((it) => {
            return it.name;
        });
        total = orderInfo.lines.reduce((tot, line) => {
            return tot + line.total
        }, 0);

        window.klaviyo.track(metric, {
            "$event_id": `${cartId}_${Math.floor(Date.now() / 1000)}`,
            "$value": total.toFixed(2),
            "ItemNames": itemNames,
            "$value_currency": "GBP",
            "Items": cartItems,
            "CheckoutURL": affiliateCode == null ? window.location.origin + orderTypeUrl + "?id=" + (orderInfo.cartId) : window.location.origin + 
                orderTypeUrl + "?id=" + orderInfo.cartId + "&" + "affiliateid=" + affiliateCode,
            "Categories": [category],
            "CartID": cartId,
            "OrderStatus": orderStatus,
            "ClickAndCollect": orderInfo.ClickAndCollect
        });
    }
}

export const completeKlaviyoCheckout = async (orderInfo, emailAddress, orderStatus) => {
    if (!window.klaviyo) {
        return;
    }

    const siteInfoResponse = await getsitesettings(SITE_ID);
    const siteInfo = siteInfoResponse?.data;

    if (!siteInfo)
        return;

    if (orderInfo && orderInfo.lines && siteInfo && siteInfo.isSiteAllowed) {
        window.klaviyo.identify({
            'email': emailAddress
        });
        const affiliateCode = sessionStorage.getItem('affiliateCode') || null;
        let cartId = "";
        let orderTypeUrl = "";
        let guarantee = "";
        let category = "";
        let metric = "Order Completed";

        if (orderInfo.product.id === ProductTypes.SELL_BACK) {
            metric = "Order Completed Sell";
            category = "Sell";
            cartId = `${siteInfo.buyCartId}${orderInfo.id}`;
            orderTypeUrl = "/selling/view-cart";
        } else {
            metric = "Order Completed Buy"
            category = "Buy";
            cartId = `${siteInfo.sellCartId}${orderInfo.id}`;
            orderTypeUrl = "/checkout/view-cart";
        }

        if (orderInfo && orderInfo.buyBackGuarantee === true) {
            guarantee = `${orderInfo.product.name}:${(orderInfo.deliverySlot.price !== 0 ? (orderInfo.currency.symbol + orderInfo.deliverySlot.price) : "Free")} 
            , Buyback Guarantee: ${orderInfo.currency.symbol}4`;
        } else {
            guarantee = `${orderInfo.product.name}:${(orderInfo.deliverySlot.price !== 0 ? (orderInfo.currency.symbol + orderInfo.deliverySlot.price) : "Free")}`;
        }
        if (orderInfo && orderInfo.refundGuarantee === true) {
            guarantee = `${orderInfo.product.name}:${(orderInfo.deliverySlot.price !== 0 ? (orderInfo.currency.symbol + orderInfo.deliverySlot.price) : "Free")} 
            ,Refund Guarantee:{orderInfo.currency.symbol}3`;
        }

           

        const cartItems = orderInfo.lines.map(function (line) {
            return {
                sku: line.currency.code,
                name: line.currency.name,
                description: line.currency.name,
                category: category,
                "other": guarantee,
                "unitPrice": line.price,
                "salePrice": line.rate.toString().slice(0, (line.rate.toString().indexOf(".")) + 5),
                "quantity": line.qty,
                "totalPrice": line.total.toFixed(2),
                "imageUrl": window.location.origin + "/assets/img/icons/flags/" + line.currency.code.toLowerCase() + ".svg",
                "productUrl": ""
            }
        });
        const itemNames = cartItems.map((it) => {
            return it.name;
        });
        const total = orderInfo.lines.reduce((tot, line) => {
            return tot + line.total
        }, 0);

        window.klaviyo.track(metric, {
            "$event_id": `${cartId}_${Math.floor(Date.now() / 1000)}`,
            "$value": total.toFixed(2),
            "ItemNames": itemNames,
            "$value_currency": "GBP",
            "Items": cartItems,
            "CheckoutURL": affiliateCode == null ? window.location.origin + orderTypeUrl + "?id=" + (orderInfo.cartId) : window.location.origin + 
                orderTypeUrl + "?id=" + orderInfo.cartId + "&" + "affiliateid=" + affiliateCode,
            "Categories": [category],
            "CartID": cartId,
            "OrderStatus": orderStatus,
            "ClickAndCollect": orderInfo.ClickAndCollect
        });
    }
}


export const paymentFailedKlaviyo = async (orderInfo, emailAddress, orderStatus) => {
    if (!window.klaviyo) {
        return;
    }

    const siteInfoResponse = await getsitesettings(SITE_ID);
    const siteInfo = siteInfoResponse?.data;

    if (!siteInfo)
        return;

    if (orderInfo && orderInfo.lines && siteInfo && siteInfo.isSiteAllowed) {
        window.klaviyo.identify({
            'email': emailAddress
        });
        const affiliateCode = sessionStorage.getItem('affiliateCode') || null;
        let cartId = "";
        let orderTypeUrl = "";
        let guarantee = "";
        let category = "";
        let metric = "Order Payment Failed";

        cartId = `${siteInfo.sellCartId}${orderInfo.id}`;
        orderTypeUrl = "/checkout/view-cart";

        if (orderInfo.product.id === ProductTypes.SELL_BACK) {
            category = "Sell";
        } else {
            category = "Buy";
        }

        if (orderInfo && orderInfo.buyBackGuarantee === true) {
            guarantee = `${orderInfo.product.name}:${(orderInfo.deliverySlot.price !== 0 ? (orderInfo.currency.symbol + orderInfo.deliverySlot.price) : "Free")} 
            , Buyback Guarantee: ${orderInfo.currency.symbol}4`;
        } else {
            guarantee = `${orderInfo.product.name}:${(orderInfo.deliverySlot.price !== 0 ? (orderInfo.currency.symbol + orderInfo.deliverySlot.price) : "Free")}`;
        }
        if (orderInfo && orderInfo.refundGuarantee === true) {
            guarantee = `${orderInfo.product.name}:${(orderInfo.deliverySlot.price !== 0 ? (orderInfo.currency.symbol + orderInfo.deliverySlot.price) : "Free")} 
            ,Refund Guarantee:{orderInfo.currency.symbol}3`;
        }           

        const cartItems = orderInfo.lines.map(function (line) {
            return {
                sku: line.currency.code,
                name: line.currency.name,
                description: line.currency.name,
                category: category,
                "other": guarantee,
                "unitPrice": line.price,
                "salePrice": line.rate.toString().slice(0, (line.rate.toString().indexOf(".")) + 5),
                "quantity": line.qty,
                "totalPrice": line.total.toFixed(2),
                "imageUrl": window.location.origin + "/assets/img/icons/flags/" + line.currency.code.toLowerCase() + ".svg",
                "productUrl": ""
            }
        });
        const itemNames = cartItems.map((it) => {
            return it.name;
        });
        const total = orderInfo.lines.reduce((tot, line) => {
            return tot + line.total
        }, 0);

        window.klaviyo.track(metric, {
            "$event_id": `${cartId}_${Math.floor(Date.now() / 1000)}`,
            "$value": total.toFixed(2),
            "ItemNames": itemNames,
            "$value_currency": "GBP",
            "Items": cartItems,
            "CheckoutURL": affiliateCode == null ? window.location.origin + orderTypeUrl + "?id=" + 
                (orderInfo.cartId) : window.location.origin + orderTypeUrl + 
                "?id=" + orderInfo.cartId + "&" + "affiliateid=" + affiliateCode,
            "Categories": [category],
            "CartID": cartId,
            "OrderStatus": orderStatus,
            "ClickAndCollect": orderInfo.ClickAndCollect
        });
    }
}

export default {
    startKlaviyoCheckout,
    completeKlaviyoCheckout,
    paymentFailedKlaviyo
}